// extracted by mini-css-extract-plugin
export default {"avatar-wrapper":"xe1z8","avatar-icon":"WJcDI"};